<template>
  <basic-dialog :show="show" @close="$emit('close')">
    <template v-slot:title>{{ value ? value.reference : "" }}</template>

    <v-tabs v-model="tabs" align-with-title>
      <v-tabs-slider color="yellow"></v-tabs-slider>
      <v-tab key="adults"> Adults </v-tab>
      <v-tab key="children"> Children </v-tab>
      <v-tab key="infants"> Infants </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item key="adults">
        <v-card flat>
          <increments-group-dialog-table
            :show="show"
            v-model="value"
            :department="department"
            :destination="destination"
            :templateItems="templateItems"
            for-adults
          ></increments-group-dialog-table>
        </v-card>
      </v-tab-item>
      <v-tab-item key="children">
        <v-card flat>
          <increments-group-dialog-table
            v-model="value"
            :show="show"
            :department="department"
            :destination="destination"
            :templateItems="templateItems"
            for-children
          ></increments-group-dialog-table>
        </v-card>
      </v-tab-item>
      <v-tab-item key="infants">
        <v-card flat>
          <increments-group-dialog-table
            v-model="value"
            :show="show"
            :department="department"
            :destination="destination"
            :templateItems="templateItems"
            for-infants
          ></increments-group-dialog-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <code v-if="debug">
      tabs:{{ tabs }} show adult pricing{{ showAdultPricing }}</code
    >
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog.vue";
import IncrementsGroupDialogTable from "./IncrementsGroupDialogTable.vue";

export default {
  name: "increments-group-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    templateItems: {
      type: Array,
      default: () => [],
    },
    templateId: {
      type: String,
      default: () => "",
    },
    department: {
      type: String,
      default: () => "FIT",
    },
    destination: {
      type: String,
      default: () => "",
    },
  },

  components: {
    BasicDialog,
    IncrementsGroupDialogTable,
  },

  data() {
    return {
      debug: false,
      tabs: null,
    };
  },
  computed: {
    showAdultPricing() {
      return this.tabs != null && this.tabs == 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/IncrementsGroupDialog.vue